import { render, staticRenderFns } from "./DashboardConfigCloud.vue?vue&type=template&id=1c962915&scoped=true&"
import script from "./DashboardConfigCloud.vue?vue&type=script&lang=js&"
export * from "./DashboardConfigCloud.vue?vue&type=script&lang=js&"
import style0 from "./DashboardConfigCloud.vue?vue&type=style&index=0&id=1c962915&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c962915",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemGroup } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VVirtualScroll } from 'vuetify/lib/components/VVirtualScroll';
installComponents(component, {VBtn,VCol,VListItem,VListItemGroup,VListItemTitle,VRow,VTextField,VVirtualScroll})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c962915')) {
      api.createRecord('1c962915', component.options)
    } else {
      api.reload('1c962915', component.options)
    }
    module.hot.accept("./DashboardConfigCloud.vue?vue&type=template&id=1c962915&scoped=true&", function () {
      api.rerender('1c962915', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/System/DashboardConfigCloud.vue"
export default component.exports